/*
  ATD - Comparativa (atd-comparison1)
  Actualiza la barra de progreso según el scroll horizontal del viewport.
  Solo aplica cuando hay overflow real (data-cols="3" en mobile).
*/
(function () {
  const sections = document.querySelectorAll('.atd-comparison1');
  if (!sections.length) return;

  sections.forEach((section) => {
    const viewport = section.querySelector('.atd-comparison1__viewport');
    const progressFill = section.querySelector('.atd-comparison1__progress-fill');
    const progressWrap = section.querySelector('.atd-comparison1__progress');
    if (!viewport || !progressFill || !progressWrap) return;

    const updateProgress = () => {
      const max = viewport.scrollWidth - viewport.clientWidth;
      if (max <= 0) {
        progressFill.style.transform = 'scaleX(0)';
        return;
      }
      const pct = Math.min(1, Math.max(0, viewport.scrollLeft / max));
      progressFill.style.transform = `scaleX(${pct})`;
    };

    let raf = null;
    viewport.addEventListener('scroll', () => {
      if (raf) return;
      raf = requestAnimationFrame(() => {
        raf = null;
        updateProgress();
      });
    });

    updateProgress();
    window.addEventListener('resize', () => {
      clearTimeout(updateProgress._t);
      updateProgress._t = setTimeout(updateProgress, 200);
    });
  });
})();
